import { WFSectionLocalResource, WfSignatureResource } from 'src/app/components/workflow/workflow';
import { AbsiTemplateResource } from '../../absi';


export class AbsiTemplateSectionRefresh {
  static readonly type = '[AbsiTemplateSection] Refresh';
  constructor(public wfTableID: number, public sectionNumber: number) { }
}

export class AbsiTemplateSectionCreate {
  static readonly type = '[AbsiTemplateSection] Create';
  constructor(public item: WfSignatureResource) { }
}

export class AbsiTemplateSectionUpdate {
  static readonly type = '[AbsiTemplateSection] Update';
  constructor(public id: number, public item: { section: WFSectionLocalResource, template: AbsiTemplateResource }) { }
}

export class AbsiTemplateSectionDelete {
  static readonly type = '[AbsiTemplateSection] Delete';
  constructor(public id: number) { }
}

export class AbsiTemplateSectionTaskDelete {
  static readonly type = '[AbsiTemplateSection] Delete Task';
  constructor(public wfTableID: number, public sectionNumber: number, public wfTaskLocalID: number) { }
}
